
<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
       <v-row class="mt-n3">
        <v-col cols="3">
            <v-autocomplete
              v-model="selectedCourses"
              :items="coursestats"
              item-value="course_id"
              item-text="course_name"
              :label="'Courses' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedFilter"
            >
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn class="white--text" small :color="primary_color" @click="resetStats()"  x-large block>
            {{ 'Reset' | translate }}
          </v-btn>
        </v-col>

      </v-row>


      <v-row no-gutters>
        <v-col cols="12">

          <v-tabs
          v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#viewcoursestats" active> {{ 'Per Course' | translate}} </v-tab>
              <v-tab href="/userstats"> {{ 'Per User' | translate }} </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs" background="#fafafa">
              <v-tab-item value="viewcoursestats">
                <div v-for="(course , index) in filteredcoursestats" :key="index" class="my-12" >
                   <v-card shaped outlined elevation="2" class="mt-4 pa-5">
                    <v-toolbar-title class="grey--text text--darken-4 text-center font-weight-bold">
                        {{course.course_name}}
                      </v-toolbar-title>
                      
                        <div class="d-flex flex-wrap"> 
                          <template>
                            <SimpleCard type="Subscribers" title="Active Subscribers" description="Number of active subscribers" color="green" :totalcount="course.no_acitve_sub"/>
                            <SimpleCard type="Modules" class="ms-0" title="Modules" description="Total Number of Modules" color="blue" :totalcount="course.modules.length"/>
                            <SimpleCard type="Users" title="Users" description="Number of users subscribed since first publishing" :color="primary_color" :totalcount="course.no_users_sub"/>
                          </template>
                        </div>
                

                  <div class="row" >
                          <div class="col" >
                            <v-card 
                              height="520"
                            >
                              <template>
                                <v-carousel
                                  show-arrows-on-hover
                              height="520"

                                >
                                  <v-carousel-item
                                    v-for="(slide, i) in slides"
                                    :key="i"
                                  >
                                    <v-card-title> {{slide.name | translate}} </v-card-title>
                                    <v-sheet
                                      color="white"
                                      height="100%"
                                    >
                                      <v-row
                                        class="ma-1"
                                        align="center"
                                        justify="center"
                                      >
                                        <template v-if="slide.type=='Bar'">
                                          <BarChart :chart-data="convertBarChart('chartData',course.learn_progress)" :chart-options="convertBarChart('chartOptions',course.learn_progress)"
                                          />
                                        </template>
                                        <template v-if="slide.type=='Doughnut'">
                                          <DoughnutChart :chart-data="convertDoughnutChart('chartData',course.pass_percentage)" :chart-options="convertDoughnutChart('chartOptions',course.learn_progress)"
                                          />
                                        </template>
                                        <template v-if="slide.type=='Line'">
                                          <LineChart :chart-data="convertLineChart('chartData', course.pass_activity)" :chart-options="convertLineChart('chartOptions',course.pass_activity)"
                                          />
                                        </template>
                                      
                                      </v-row>
                                    </v-sheet>
                                  </v-carousel-item>
                                </v-carousel>
                              </template>
                            </v-card>
                          </div>
                    
                    <div class="col-md-auto">
                      <template>
                        <v-card
                          class="mx-auto overflow-auto"
                          max-width="400"
                          height="520"
                        >
                          <v-toolbar
                            :color="primary_color"
                            dark
                            style="position: sticky;
                            top: 0;
                            z-index: 999;"
                          >
                            <v-toolbar-title>{{ "Course Modules" | translate}}</v-toolbar-title>
                          </v-toolbar>


                            <v-list two-line >
                                <v-list-group
                                v-for="(item, index) in course.modules"
                                :key="index"
                                v-model="item.active"
                                :prepend-icon="item.action"
                                no-action
                                >
                                  <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.module_title"></v-list-item-title>
                                        <v-list-item-action-text
                                            :class="item.active ? 'text-blue':'text--primary'"
                                        > {{'Version' | translate}} {{item.module_version_no}}</v-list-item-action-text>

                                    </v-list-item-content>
                                      <v-list-item-action>
                                        <v-list-item-action-text v-text="item.module_version_type"></v-list-item-action-text>
                                        <v-icon :class="item.active ? 'text-blue':'text-grey'"> mdi-book </v-icon>
                                        
                                      </v-list-item-action>
                                  </template>

                                  <v-card elevation="5" class="pa-2 pb-6 mb-2"> 
                                      <template>
                                      <SmallCard :width="100" title="Average Time Spent" color="grey" :value="(item.avg_time_spent)?(item.avg_time_spent):'No Time Spent' | translate "/>
                                      <SmallCard :width="100" title="Average Number Of Attempts to Complete" color="green" :value="(item.avg_attempts)?(item.avg_attempts):'Not Attempted' | translate"/>
                                      <DoughnutChart :width="200" :height="200" :chartData="convertModuleDoughnutChart('chartData',item.progress_activity)" :chartOptions="convertModuleDoughnutChart('chartOptions',item.progress_activity)"
                                      />
                                      </template>
                                  </v-card>
                                </v-list-group>
                            </v-list>
                        </v-card>

                      </template>
                    </div>
                   
                  </div>
                   </v-card>

                </div>

              </v-tab-item>
          </v-tabs-items>

           <v-tabs-items v-model="tabs">
              <v-tab-item value="viewcoursewisepassingpercentage">
                  <v-card class="d-flex flex-wrap"> 
                    <template>
                    </template>
                  </v-card>
              </v-tab-item>
           </v-tabs-items>

        </v-col>
      </v-row>
    </v-container>

</v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_COMPANY_SETTINGS,
  FETCH_COURSE_STATS,
  RESET_STATE
} from "@/store/actions.type";
export default {
  name: "Quiz",
  async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE),
    await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
    await store.dispatch(FETCH_COURSE_STATS, '');
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Course Statistics",
      search: "",
      primary_color: '',
      tabs:null,
      isLoading:false,
      storage_url: "",
      selectedCourses:[],
      filteredcoursestats:null,

      //carousel for slides
      slides: [
        {
          'name' : 'Learning Progress of Users',
          'type' : 'Bar',
        },
        {
          'name' : 'Passed Percentage of Currently Subscribed Users',
          'type' : 'Doughnut',
        },
        {
          'name' : 'Pass activity over time',
          'type' : 'Line',
        },
      ],
    };
  },
  components: {
    Header: () => import("@/components/header/Header"),
    BarChart: () => import("@/components/charts/Bar"),
    DoughnutChart: () => import("@/components/charts/Doughnut"),
    LineChart: () => import("@/components/charts/Line"),
    SimpleCard: () => import("@/components/cards/SimpleCard"),
    SmallCard: () => import("@/components/cards/SmallCard"),
  },
  computed: {
    ...mapGetters(['currentUser','loadingdata','companysettings','coursestats']),
   
  },
  created() {
    this.storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
    this.filteredcoursestats = this.coursestats;
    
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color  = company_meta.primary_color
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }

    if(this.companysettings.hasOwnProperty('setting_data')){
        this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
        this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
    }

  },
  methods: {
    resetStats(){
      this.selectedCourses = [];
      this.filteredcoursestats = this.coursestats;
    },
    convertDoughnutChart(option, data){
      if(option == 'chartData'){
          let chartData = {
          labels: [this.$t('Passed'), this.$t('Not Passed')],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651'],
              data: [data.passed_percent, data.not_passed_percent]
            }
          ]
        }
        return chartData;
      }else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom',
              }
          }
        }
        return chartOptions;
      }
    },
    convertBarChart(option, data){
      if(option=='chartData'){
        let datalabels = Object.keys(data);
        let datavalues = Object.values(data);
        // datavalues = [10, 20, 16, 0, 0, 0, 0, 10, 2, 0, 1, 1, 0, 1, 0, 0, 50, 90, 0, 2]
        let chartData = {
          labels: datalabels,
          datasets: [{
                label: this.$t("Number of Users"),
                data: datavalues,
                backgroundColor: ["#c4e5ff","#c4e5ff","#c4e5ff","#c4e5ff","#97aef1","#97aef1","#97aef1","#97aef1","#F8C471","#F8C471","#F8C471","#F8C471","#F7DC6F","#F7DC6F","#48C9B0","#48C9B0","#138D75","#138D75","#138D75","#138D75"],
                // borderColor: ["#b0ddff","#b0ddff","#b0ddff","#b0ddff","#7898fa","#7898fa","#7898fa","#7898fa","#e3ad56","#e3ad56","#e3ad56","#e3ad56","#d9ba3f","#d9ba3f","#48C9B0","#27a189","#097d66","#097d66","#097d66","#097d66"],
                // borderColor: ["#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000","#000"],
                // borderWidth: 2,
                barThickness: 15,
          }]
        }
        return chartData;
      }
      else{
        let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                  title:{
                      display: true,
                      text: this.$t("Percentage Of Course Completed"),
                  },
                  //  ticks: {
                  //       // Include a dollar sign in the ticks
                  //       callback: function(value, index, ticks) {
                  //           return  value+ '%';
                  //       }
                  //   }
                },
                y: {
                    title:{
                        display: true,
                        text: this.$t("Number of Users"),
                    },
                    ticks:{
                      stepSize: 1,
                    }
                   
                }
            },
            plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    }
            },
            //   layout:{
            //     padding: 22,
            //   },
        };
        return chartOptions
      }
      
    },
    convertLineChart(option, data){
      if(option=='chartData'){
        let datalabels = Object.keys(data);
        let datavalues = Object.values(data);
        let coursedataset = [];

          coursedataset= [{
                label: this.$t("Pass Activity of Users in Weeks"),
                backgroundColor: this.primary_color,
                data: datavalues,
                borderColor: this.primary_color,
                fill: false,
                tension: 0.1
          }];
        let chartData = {
          labels: datalabels,
          datasets: coursedataset
        }

        return chartData;
      }
      else{
          let chartOptions= {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                }
            },
            scales: {
              x: {
                title:{
                  display: true,
                  text: this.$t("Weeks To Pass")
                }
              },
              y: {
                title:{
                  display: true,
                  text: this.$t("Number of Users")
                },
                 ticks:{
                  stepSize: 1,
                },
                min:0,
              }
            }
          };
          return chartOptions;
      }
      
    },
    convertModuleDoughnutChart(option,data){
      if(option=='chartData'){
        let chartData = {
          labels: [this.$t('Started'), this.$t('Not Started'), this.$t('Finished')],
          datasets: [
            {
              backgroundColor: ['#2471A3','#D4AC0D','#196F3D'],
              data: [data.started, data.not_started, data.finished]
            }
          ]
        }
        return chartData;
      }
      else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              title: {
                display: true,
                text: this.$t("Subscribed Users Learning Status")
              },
              legend: {
                  display: true,
                  position: 'bottom',
              }
          }
        }
        return chartOptions;
      }
    },
    changedFilter(){
      if(!this.selectedCourses.length){
          this.filteredcoursestats = this.coursestats;
      }
      else{
        this.filteredcoursestats = this.coursestats.filter(v => this.selectedCourses.includes(v.course_id));  
      }
      
    },
    
  
  }
};
</script>

<style scoped>
.v-tabs-items {
    background-color: #fafafa;
}

</style>